/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
/// <reference path="./reportingHierarchyBranchPicker.controller.ts" />

module Meevo.Components.Controls {
    "use strict";

    export interface IReportingHierarchyBranchPicker {
    }

    export class ReportingHierarchyBranchPicker implements angular.IComponentOptions {
        templateUrl = "app/components/controls/reportingHierarchyBranchPicker/reportingHierarchyBranchPicker.template.html";
        controller = Meevo.Components.Controls.ReportingHierarchyBranchPickerController;
        bindings: any = {
            tree: '<?',
            nodesById: '<?',
            hierarchyId: '<?',
            selected: '=ngModel',
            chooseAllOption: '<?',
            onChange: '&?',
            hasChanges: '<?',
            onChangeConfirm: '&?',
            disabled: '<ngDisabled',
            layout: '@'
        }
    }

    angular.module("meevo.components.controls")
        .component("meevoReportingHierarchyBranchPicker", new ReportingHierarchyBranchPicker());
}